import cx from "classnames";
import { PolymorphicElement } from "../../primitive";
import css from "./List.module.css";

type ListTypes = "default" | "numeric" | "listbox";

export interface IListProps {
  type?: ListTypes;
  className?: string;
  children: JSX.Element | JSX.Element[] | any;
  ariaLabel: string;
  orientation?: "verical" | "horizontal";
}

const BASE_CLASS = "f-AtomList";

export const List = ({
  orientation = "verical",
  type = "default",
  children,
  ariaLabel,
}: IListProps) => {
  const isListBox = type === "listbox";
  const isNumeric = type === "numeric";
  const tagName = isNumeric ? "ol" : "ul";

  const className = cx({
    [css[BASE_CLASS]]: !isListBox,
    [css[`${BASE_CLASS}Box`]]: isListBox,
    [css[`${BASE_CLASS}--orientation-horizontal`]]:
      orientation === "horizontal",
  });

  return (
    <PolymorphicElement
      as={tagName}
      role="list"
      aria-label={ariaLabel}
      className={className}
    >
      {children}
    </PolymorphicElement>
  );
};
